import type { Task } from '../types';

export function searchTasks(tasks: Task[], query: string): Task[] {
  const q = query.trim().toLowerCase();
  if (!q) return tasks;
  const terms = q.split(/\s+/).filter(Boolean);
  return tasks.filter((t) => {
    const haystack = [
      t.title,
      t.description ?? '',
      t.source?.forwardNote ?? '',
      t.source?.originalFrom ?? '',
      t.source?.originalSubject ?? '',
      t.source?.originalBodyText ?? '',
      ...t.notes.map((n) => n.body),
    ]
      .join(' ')
      .toLowerCase();
    return terms.every((term) => haystack.includes(term));
  });
}
